import { styled } from '@mui/material/styles';
import MuiDivider from '@mui/material/Divider';

export const ItemButtonIcon = styled(`span`)(({ theme }) => ({
  '.MuiBox-root': {
    svg: {
      position: 'relative',
      top: 2,
      path: { fill: theme.palette.brand.darkGreen }
    }
  },
  svg: {
    fill: theme.palette.brand.darkGreen,
    position: 'relative',
    top: 2
  }
}));

export const Divider = styled(MuiDivider)(({ theme }) => () => ({
  backgroundColor: theme.palette.neutrals.beige3,
  height: '1px',
  borderBottom: 0,
  marginTop: theme.spacing(3),
  marginBottom: theme.spacing(3)
}));
